import { render, staticRenderFns } from "./recruition.vue?vue&type=template&id=97d514ce&scoped=true"
import script from "./recruition.vue?vue&type=script&lang=ts"
export * from "./recruition.vue?vue&type=script&lang=ts"
import style0 from "./recruition.vue?vue&type=style&index=0&id=97d514ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d514ce",
  null
  
)

export default component.exports